export enum States {
  ITALY = 'Italy',
  VATICAN = 'Vatican',
  SANMARINO = 'San Marino'
}
